import { render } from "./TabEmergency.vue?vue&type=template&id=631bc22f&ts=true"
import script from "./TabEmergency.vue?vue&type=script&lang=ts"
export * from "./TabEmergency.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__